import {DealBean} from 'common/api/api.ts'
import {
    DictionarySelector,
    DictionarySelectorProps,
    enumValueToLabelValue
} from 'common/components/dictionary/DictionarySelector.tsx'
import {FC} from 'react'
import FormatTypesEnum = DealBean.FormatTypesEnum

export const FormatTypeSelector: FC<DictionarySelectorProps> = (props) =>
    <DictionarySelector {...props} cacheKey="formatType"
                        loader={() => enumValueToLabelValue([
                            FormatTypesEnum.Audio,
                            FormatTypesEnum.Banner,
                            FormatTypesEnum.Native,
                            FormatTypesEnum.Pop,
                            FormatTypesEnum.Push,
                            FormatTypesEnum.Video,
                        ])}
                        mode={ props.multiple ? (props.mode ?? 'multiple') : undefined }/>